<nav aria-label="breadcrumbs" class="breadcrumbs">
  <div class="container">
    <ol
      class="breadcrumb"
      itemscope
      itemtype="https://schema.org/BreadcrumbList"
    >
      <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index">
        <li
          class="breadcrumb-item"
          [ngClass]="{ active: i === breadcrumbs.length - 1 }"
          itemprop="itemListElement"
          itemscope
          itemtype="https://schema.org/ListItem"
        >
          <span class="breadcrumb-item-wrapper">
            <ng-container *ngIf="i !== 0">
              <hdi-icon
                [iconName]="'arrow-right-long'"
                [iconPrefix]="'far'"
                [color]="
                  i === breadcrumbs.length - 1 ? Colors.BLACK : Colors.GREY
                "
                [size]="viewport === 'desktop' ? Sizes.SMALL : Sizes.XSMALL"
                [style.margin]="
                  viewport === 'desktop' ? '0 0.5rem' : '0 0.25rem'
                "
              ></hdi-icon>
            </ng-container>
            <hdi-link
              *ngIf="breadcrumb.url"
              [label]="breadcrumb.title"
              [type]="breadcrumbNoIconType"
              [hrefType]="BreadcrumbHrefType.ANGULAR_ROUTE"
              [href]="breadcrumb.url"
              [viewport]="viewport"
              [color]="
                i === breadcrumbs.length - 1 ? Colors.BLACK : Colors.GREY
              "
            ></hdi-link>
            <span
              [attr.data-viewport]="viewport"
              *ngIf="!breadcrumb.url"
              class="current"
              itemprop="title"
              >{{ breadcrumb.title }}</span
            >
          </span>
          <meta itemprop="position" [content]="i + 1" />
        </li>
      </ng-container>
    </ol>
  </div>
</nav>
